import { PublicConfig } from '@rse/core'
import { firebaseCollectionNames } from '../firebaseConstants'
import { usePersistentCollectionItem } from './usePersistentCollectionItem'

export function usePublicConfig() {
  return usePersistentCollectionItem<PublicConfig>(firebaseCollectionNames.publicConfig)
}
